
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-6 py-20 overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-purple-600/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-pink-600/20 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-cyan-600/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-600/20 border border-purple-500/30 rounded-full backdrop-blur-sm">
              <span className="text-sm">Hello there! 👋</span>
            </div>

            <div>
              <h1 className="text-6xl md:text-7xl font-bold mb-4 bg-gradient-to-r from-white via-purple-200 to-pink-200 bg-clip-text text-transparent">
                I'm Hafeez
              </h1>
              <h2 className="text-3xl md:text-4xl font-semibold text-purple-400 mb-6">
                Thumbnail Designer
              </h2>
              <p className="text-gray-300 text-lg leading-relaxed max-w-xl">
                Creating high-impact YouTube thumbnails that increase engagement and drive clicks. I specialize in visual storytelling that converts viewers into loyal subscribers through strategic design and color psychology.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 py-8">
              <div className="text-center">
                <div className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  4+
                </div>
                <div className="text-sm text-gray-400 mt-1">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  100+
                </div>
                <div className="text-sm text-gray-400 mt-1">Thumbnails Designed</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  50+
                </div>
                <div className="text-sm text-gray-400 mt-1">Happy Clients</div>
              </div>
            </div>

            {/* Buttons & Social */}
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="#portfolio"
                className="px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full font-semibold shadow-lg shadow-purple-500/50 hover:shadow-purple-500/80 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                View Portfolio
              </a>

              <div className="flex items-center gap-3">
                <a
                  href="https://www.instagram.com/hafeez.dsg/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-purple-600/20 border border-purple-500/30 rounded-full hover:bg-purple-600/40 transition-all duration-300 hover:scale-110 cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a
                  href="https://x.com/AbdulHafee92342"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-purple-600/20 border border-purple-500/30 rounded-full hover:bg-purple-600/40 transition-all duration-300 hover:scale-110 cursor-pointer"
                  aria-label="X (Twitter)"
                >
                  <i className="ri-twitter-x-line text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Right Content - Profile Image */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative">
              {/* Floating badges */}
              <div className="absolute -top-4 -left-4 px-4 py-2 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-sm font-semibold shadow-lg shadow-purple-500/50 animate-bounce z-10">
                Featured
              </div>
              <div className="absolute -bottom-4 -right-4 px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full text-sm font-semibold shadow-lg shadow-cyan-500/50 z-10">
                Available
              </div>

              {/* Profile Image with glow */}
              <div className="relative w-80 h-80 md:w-96 md:h-96">
                <div className="absolute inset-0 bg-gradient-to-r from-purple-600 via-pink-600 to-cyan-500 rounded-3xl blur-xl opacity-60 animate-pulse"></div>
                <div className="relative w-full h-full bg-gradient-to-br from-purple-900/50 to-pink-900/50 rounded-3xl overflow-hidden border-2 border-purple-500/30 shadow-2xl">
                  <img
                    src="https://static.readdy.ai/image/2d224474eed6143861933550dca87b40/d9fd49f4629ad5813493aa3592d5a2d3.jpeg"
                    alt="Hafeez - Thumbnail Designer"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
